import { render, staticRenderFns, recyclableRender, components } from "./supplier_chat.vue?vue&type=template&id=50193720&"
var renderjs
import script from "./supplier_chat.vue?vue&type=script&lang=js&"
export * from "./supplier_chat.vue?vue&type=script&lang=js&"
import style0 from "./supplier_chat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/plus/chat/supplier_chat.vue"
export default component.exports